import { SignIn } from "@clerk/react";
import { AuthLayout } from "./auth-layout";

export default function SignInPage() {
  return (
    <AuthLayout>
      <SignIn />
    </AuthLayout>
  );
}
